<form [formGroup]="form">
<div class="modal-header">
  <h4 class="modal-title">{{titleKey | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p [innerHTML]="infoMessageKey | translate"></p>
    <p *ngIf="!isRegisteredUser">{{'login.login_part.functions_availability_text' | translate}}</p>
    <div class="w-100" *ngIf="!isRegisteredUser">
      <div *ngIf="cdcEnabled" class="mb-3 row d-flex justify-content-center">
        <div class="col-md-8">
          <a href="javascript:void(0)" data-gatm="login.loginButton"
             (click)="cdcLogin()" [class.event-disabled]="!cdcInitialized"
             class="btn btn-secondary btn-lg px-2 col-lg-12 d-flex align-items-center gap-2">
            <app-svg-icon type="user"/>
            {{(cdcInitialized ? 'login.login_part.login_button.label' : 'login.customer_data_cloud_loading') | translate}}
          </a>
        </div>
      </div>
      <div *ngIf="cdcEnabled" class="mb-3 row d-flex justify-content-center">
        <div class="col-md-8">
          <a class="u" data-gatm="login.signup_button" href="javascript:void(0)" (click)="cdcSignUp()"
             appActionLogId="login.signup_button">
            <i class="mdi mdi-chevron-right pr-1"></i>
            {{'login.signup_part.signup_button.label' | translate}}
          </a>
        </div>
      </div>
      <section *ngIf="loginNotifications?.length > 0">
        <hr class="my-4">
        <!-- login system notifications -->
        <section class="login-info-notice">
          <div *ngFor="let notification of loginNotifications" class="row">
            <div class="col-lg-12" [innerHTML]="getNotificationText(notification)"></div>
          </div>
          <a *ngIf="hasTemporaryLoginNotifications" href="javascript:void(0)" (click)="confirmNotifications()" class="btn btn-primary">
            {{'global.label.ok' | translate}}
        </a>
        </section>
      </section>
      <hr *ngIf="(cdcEnabled || loginNotifications?.length > 0) && localAuthenticationEnabled" class="my-4">
      <div *ngIf="localAuthenticationEnabled" class="row d-flex justify-content-center">
        <p class="col-md-8 font-weight-bold">{{'login.login_part.message' | translate}}</p>
      </div>
      <div *ngIf="localAuthenticationEnabled" class="mb-3 row d-flex justify-content-center">
        <div class="col-md-8">
          <input appInputAutoFocus
                type="text"
                name="username"
                class="form-control"
                spellcheck="false"
                (keyup.enter)="onEnter()"
                [placeholder]="('login.login_part.username.placeholder' | translate) + ': *'"
                formControlName="username">
        </div>
      </div>
      <div *ngIf="localAuthenticationEnabled" class="row d-flex justify-content-center">
        <div class="col-md-8">
          <input type="password"
                name="password"
                class="form-control"
                (keyup.enter)="onEnter()"
                [placeholder]="('login.login_part.password.placeholder' | translate) + ': *'"
                formControlName="password">
        </div>
      </div>
      <div *ngIf="localAuthenticationEnabled" class="row">&nbsp;</div>
     </div>
  </div>
</div>
<div class="modal-footer">
  <button id="continue_without_login_button" class="btn btn-secondary btn-forward" type="button" (click)="close()" *ngIf="!isRegisteredUser">
    {{'relogin_action.continue_without_login' | translate}}
  </button>
  <button class="btn btn-primary btn-forward" type="button" (click)="login()" *ngIf="!isRegisteredUser && localAuthenticationEnabled">
    {{'login.login_part.login_button.label' | translate}}
  </button>
  <button class="btn btn-primary btn-forward" type="button" (click)="close()" *ngIf="isRegisteredUser">
    {{'global.label.continue' | translate}}
  </button>
</div>
</form>
